export const SET_MANAGEMENT_LEFT_PANEL_COLLAPSED = "SET_MANAGEMENT_LEFT_PANEL_COLLAPSED";
export const SET_PROJECT_COUNTS = "SET_PROJECT_COUNTS";

export interface ManagementLayoutState {
  isLeftPanelCollapsed: boolean;
  // Left-nav badge counts. undefined = not loaded yet (badge stays hidden).
  myProjectsCount?: number;
  favoritesCount?: number;
}

interface SetManagementLeftPanelCollapsedAction {
  type: typeof SET_MANAGEMENT_LEFT_PANEL_COLLAPSED;
  meta: {
    params: {
      isLeftPanelCollapsed: boolean;
    };
  };
}

// Partial update: only the provided counts are written; the other is preserved.
export interface ISetProjectCountsParams {
  myProjectsCount?: number;
  favoritesCount?: number;
}

interface SetProjectCountsAction {
  type: typeof SET_PROJECT_COUNTS;
  meta: {
    params: ISetProjectCountsParams;
  };
}

export type ManagementLayoutActionTypes = SetManagementLeftPanelCollapsedAction | SetProjectCountsAction;
